export function downloadBlob(data, filename, type) {
	const blob = type ? new Blob([data], { type }) : new Blob([data])
	const url = window.URL.createObjectURL(blob)
	const link = document.createElement('a')

	link.href = url
	link.download = filename
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)

	window.setTimeout(() => {
		window.URL.revokeObjectURL(url)
	}, 0)
}
